module.exports = __webpack_public_path__ + "static/media/sort_selected.7fb20723.svg";